export default "__VITE_ASSET__CN4wmkEW__"